export const AI_CHAT_CONVERSATION_STORAGE_KEY = 'cc_ai_chat_conversation_id';
export const AI_CHAT_MESSAGES_STORAGE_KEY = 'cc_ai_chat_messages';
